<template>
  <div>
    <div style="width: 100%; overflow-y: scroll; height: 82vh">
      <div class="box insuranceForm">
        <div class="basicInformation">
          <div style="
              text-align: center;
              font-size: 24px;
              font-weight: 700;
              padding: 10px 0;
            ">
            订单确认
          </div>
          <div class="basicInformation-title">
            <img :src="detail.imagePath"
                 alt="" />
            <div class="title">
              {{ detail.name }}
              <div class="price">
                预估总价： <span style="color: red; font-weight: 700">0元</span>
              </div>
            </div>
            <div class="btn">
              <el-button plain
                         size="mini"
                         @click="back">上一步</el-button>
            </div>
          </div>
          <div class="baseForm">
            <div class="baseForm-title">基本信息</div>
            <div>
              <el-form ref="form"
                       :inline="true"
                       :model="form"
                       label-width="95px"
                       size="mini"
                       v-enterToNext="true">
                <el-form-item label="投保单位"
                              prop="forShort">
                  <el-input v-model="form.insuredCompanyName"
                            maxlength="20"
                            disabled></el-input>
                </el-form-item>

                <el-form-item label="被投保单位"
                              prop="sex">
                  <el-select v-model="form.passivityInsuredCompanyId"
                             clearable
                             filterable
                             placeholder="请选择"
                             ref="myCompany">
                    <el-option v-for="item in companyList"
                               :key="item.Id"
                               :label="item.customerName"
                               :value="item.id">
                    </el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="行业类别"
                              prop="sex">
                  <el-input v-model="form.industryType"
                            maxlength="20"></el-input>
                </el-form-item>
                <el-form-item label="企业性质"
                              prop="sex">
                  <el-input v-model="form.enterpriseNature"
                            maxlength="20"></el-input>
                </el-form-item>
              </el-form>
            </div>
          </div>
        </div>
        <div class="base"
             style="padding-top: 20px">
          <div class="baseForm"
               style="margin-top: 0px">
            <div class="baseForm-title">投保信息</div>
            <div>
              <el-form ref="form"
                       :inline="true"
                       :model="form"
                       label-width="95px"
                       size="mini">
                <el-row>
                  <el-form-item label="缴费方式"
                                prop="forShort">
                    <el-input v-model="form.payWay"
                              maxlength="20"></el-input>
                  </el-form-item>
                </el-row>
                <el-row>
                  <el-form-item label="开始日期"
                                prop="sex">
                    <el-date-picker style="width: 100%"
                                    v-model="form.startDate"
                                    value-format="yyyy-MM-dd"
                                    type="date"
                                    placeholder="选择开始日期">
                    </el-date-picker>
                  </el-form-item>
                  <el-form-item label="结束日期"
                                prop="sex">
                    <el-date-picker style="width: 100%"
                                    v-model="form.endDate"
                                    value-format="yyyy-MM-dd"
                                    type="date"
                                    placeholder="选择开始日期">
                    </el-date-picker>
                  </el-form-item>
                </el-row>
              </el-form>
            </div>
          </div>
        </div>
        <div class="base"
             style="padding-top: 20px">
          <div class="baseForm"
               style="margin-top: 0px">
            <div class="baseForm-title">
              被投保人信息
              <div>
                <el-button icon="el-icon-edit"
                           plain
                           size="small"
                           type="success">批量修改工种</el-button>
                <el-button icon="el-icon-upload"
                           plain
                           size="small"
                           @click="noticeDialogVisible = true"
                           type="success">录入人员</el-button>
                <el-button size="small "
                           type="primary"
                           plain
                           @click="del"
                           icon="el-icon-delete">删除</el-button>
              </div>
            </div>
            <div>
              <MyTable :tableData="tableData"
                       :tableConfig="tableConfig"
                       tableType="selection"
                       @selectionChange="handleSelectionChange"
                       :height="'400px'"
                       :indexFlag="true">
                <template v-slot:index="slotData">
                  {{ slotData.scope.$index + 1 }}
                </template>
                <template v-slot:healthStateText="slotData">
                  <el-input size="small"
                            v-model="slotData.scope.row.healthStateText"></el-input>
                </template>
                <template v-slot:insuranceWorkCategoryName="slotData">
                  <el-select v-model="slotData.scope.row.myName"
                             placeholder="请选择工种名称"
                             size="small"
                             :ref="'mySelected' + slotData.scope.$index"
                             @change="change($event, slotData.scope.$index)">
                    <el-option v-for="item in categoryList"
                               :key="item.id"
                               :label="item.name"
                               :value="item.code">
                    </el-option>
                  </el-select>
                </template>
              </MyTable>
            </div>
          </div>
        </div>
        <div class="base"
             style="padding-top: 20px">
          <div class="baseForm"
               style="margin-top: 0px">
            <div class="baseForm-title">发票</div>
            <div>
              <el-form ref="form"
                       :inline="true"
                       :model="form"
                       label-width="95px"
                       size="mini">
                <el-row>
                  <el-form-item label="是否开发票"
                                prop="forShort">
                    <el-radio-group v-model="radio1">
                      <el-radio-button label="是"></el-radio-button>
                      <el-radio-button label="否"></el-radio-button>
                    </el-radio-group>
                  </el-form-item>
                </el-row>
                <el-row>
                  <el-form-item label="发票类型"
                                prop="sex">
                    <el-date-picker style="width: 100%"
                                    v-model="searchForm.createDate"
                                    value-format="yyyy-MM-dd"
                                    type="date"
                                    placeholder="选择开始日期">
                    </el-date-picker>
                  </el-form-item>
                  <el-form-item label="开票对象"
                                prop="sex">
                    <el-date-picker style="width: 100%"
                                    v-model="searchForm.createDate"
                                    value-format="yyyy-MM-dd"
                                    type="date"
                                    placeholder="选择开始日期">
                    </el-date-picker>
                  </el-form-item>
                </el-row>

                <el-form-item label="发票抬头"
                              prop="sex">
                  <el-input v-model="form.cName"
                            maxlength="20"></el-input>
                </el-form-item>
                <el-form-item label="税号"
                              prop="sex">
                  <el-input v-model="form.cName"
                            maxlength="20"></el-input>
                </el-form-item>
              </el-form>
            </div>
          </div>
        </div>
        <div class="base"
             style="padding-top: 20px">
          <div class="baseForm"
               style="margin-top: 0px">
            <div class="baseForm-title">投保须知</div>
            <div></div>
          </div>
        </div>
        <div class="base"
             style="padding-top: 20px">
          <div class="baseForm"
               style="margin-top: 0px">
            <div class="baseForm-title">备注</div>
            <div>
              <el-input type="textarea"
                        :rows="4"
                        placeholder="请输入内容"
                        v-model="remark">
              </el-input>
            </div>
          </div>
        </div>
        <div style="padding-top: 20px; text-align: center">
          <el-button plain
                     size="small"
                     @click="back">上一步</el-button>
          <el-button size="small"
                     :loading="submitLoading"
                     type="primary"
                     @click="onSubmit('form')">确认</el-button>
        </div>
      </div>
    </div>
    <notifyCard @colseDrawer="noticeDialogVisible = false"
                :visible.sync="noticeDialogVisible"
                @add="add"
                :filterate="tableData" />
  </div>
</template>

<script>
import MyTable from "@/components/Table";
import notifyCard from "/src/views/purchaseInsurance/notifyCard";

export default {
  components: {
    MyTable,
    notifyCard,
  },
  data () {
    return {
      searchForm: {},
      activeName: "first",
      form: {},
      loading: false,
      noticeDialogVisible: false,
      radio1: "",
      remark: "",
      tableConfig: [
        {
          field: "cname",
          label: "姓名",
          align: "center",

          flag: true,
        },
        {
          field: "identityCard",
          label: "身份证",
          align: "center",

          flag: true,
        },
        {
          field: "sex",
          label: "性别",
          align: "center",

          flag: true,
        },
        {
          field: "healthStateText",
          label: "健康信息",
          align: "center",
          slotName: "healthStateText",
          flag: true,
        },
        {
          field: "insuranceWorkCategoryName",
          label: "工种名称",
          align: "center",
          slotName: "insuranceWorkCategoryName",
          flag: true,
        },
        {
          field: "insuranceWorkCategoryCode",
          label: "工种代码",
          align: "center",
          flag: true,
        },
      ],
      tableData: [],
      categoryList: [],
      id: "",
      companyList: [],
      submitLoading: false,
      detail: "",
      industryList: [],
    };
  },
  mounted () {
    let encodedObj = this.$route.query.data;
    let Obj = this.$route.query.myObj;

    let obj = JSON.parse(decodeURIComponent(encodedObj));
    let myObj = JSON.parse(decodeURIComponent(Obj));
    this.detail = myObj;
    this.tableData = obj;
    this.id = myObj.id;
    console.log(this.$route.query.id);
    this.form.insuredCompanyId = JSON.parse(
      localStorage.getItem("CompanyDetail")
    ).id;
    this.form.insuredCompanyName = JSON.parse(
      localStorage.getItem("CompanyDetail")
    ).companyName;
    this.InsuranceWorkCategoryList();
    this.getCompanyList();
    this.form.startDate = this.getNowFormatDate();
    this.GetEnumListByClassName();
  },
  methods: {
    change (value, index) {
      this.$nextTick(() => {
        this.$set(this.tableData[index], "insuranceWorkCategoryCode", value);
        this.$set(
          this.tableData[index],
          "insuranceWorkCategoryName",
          this.$refs["mySelected" + index].selected.label
        );
      });
    },
    onSubmit (formName) {
      this.$refs[formName].validate((valid) => {
        if (!valid) return;
        this.$confirm("确认订单吗", "提示", {
          confirmButtonText: "确 认",
          cancelButtonText: "关 闭",
          type: "warning",
        })
          .then(() => {
            this.submitLoading = true;

            let sendData = {
              insuredCompanyId: this.form.insuredCompanyId,
              insuredCompanyName: this.form.insuredCompanyName,
              passivityInsuredCompanyId: this.form.passivityInsuredCompanyId,
              passivityInsuredCompanyName: this.$refs.myCompany.selected.label,
              industryType: this.form.industryType,
              enterpriseNature: this.form.enterpriseNature,
              payWay: this.form.payWay,
              startDate: this.form.startDate,
              endDate: this.form.endDate,
              remark: this.remark,
              insuranceProductId: this.id,
              insuranceOrderTheInsuredList: this.tableData,
            };
            this.$api.Insurance.InsuranceCompanyCreateOrder(sendData).then(
              (res) => {
                this.submitLoading = false;

                if (res.error === false) {
                  this.$message.success("确认成功");

                  this.$router.replace("/insuranceOrders");
                } else {
                  this.$message.error(res.msg);
                }
              }
            );
          })
          .catch(() => { });
      });
    },
    getNowFormatDate () {
      let date = new Date(),
        year = date.getFullYear(), //获取完整的年份(4位)
        month = date.getMonth() + 1, //获取当前月份(0-11,0代表1月)
        strDate = date.getDate(); // 获取当前日(1-31)
      if (month < 10) month = `0${month}`; // 如果月份是个位数，在前面补0
      if (strDate < 10) strDate = `0${strDate}`; // 如果日是个位数，在前面补0
      return `${year}-${month}-${strDate}`;
    },
    getCompanyList () {
      this.$api.customer.getAllCustomerList().then((res) => {
        if (res.error === false) {
          this.companyList = res.data;
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    GetEnumListByClassName () {
      this.$api.Enumeration.GetEnumListByClassName(["Industry"]).then((res) => {
        if (res.error === false) {
          this.industryList = res.Data.enumList;
          console.log(this.industryList);
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    InsuranceWorkCategoryList () {
      this.$api.Insurance.InsuranceWorkCategoryList().then((res) => {
        if (res.error === false) {
          this.categoryList = res.data;

        } else {
          this.$message.error(res.msg);
        }
      });
    },
    del () {
      this.tableData.forEach((item, i) => {
        this.Ids.forEach((v) => {
          if (item.id == v) {
            this.tableData.splice(i, 1);
          }
        });
      });
    },
    add (value) {
      this.tableData.push(value);
      console.log(value);
    },
    back () {
      this.$router.go(-1);
    },
    handleSelectionChange (selection) {
      this.Ids = selection.map((v) => {
        return v.id;
      });
    },
  },
};
</script>
<style lang="less">
.insuranceForm {
  .el-form-item {
    width: 48%;
    .el-form-item__content {
      width: 85%;
    }
    .el-select {
      width: 100%;
    }
  }
}
</style>
<style lang="less" scoped>
.box {
  width: 1600px;
  margin: 0 auto;

  .basicInformation,
  .base {
    background-color: white;
    border-radius: 6px;
    margin-top: 10px;
    padding: 20px;
    position: relative;
    .basicInformation-title {
      display: flex;
      img {
        width: 110px;
        height: 110px;
        border-radius: 8px;
      }
      .btn {
        position: absolute;
        right: 20px;
        bottom: 175px;
        z-index: 999;
      }
      .title {
        margin-left: 15px;
        font-size: 19px;
        font-weight: 700;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        .price {
          font-weight: normal;
          font-size: 16px;
        }
      }
    }
    .baseForm {
      margin-top: 35px;

      .baseForm-title {
        display: flex;
        justify-content: space-between;
        align-items: center;
        font-size: 16px;
        font-weight: 700;
        margin-bottom: 20px;
      }
    }
  }
}
</style>